module.exports = __webpack_public_path__ + "img/png.b204f242.png";